import { z } from 'zod';

export const teamPlayerRegistrationSchema = z.object({
	email: z.string().min(1, 'Email is required').email(),
	phoneNumber: z.string().min(8, 'Phone number must contain minimum 8 characters.'),
	invitationCode: z.string().min(1, 'Invitation code is required')
});

export type TeamPlayerRegistrationData = z.infer<typeof teamPlayerRegistrationSchema>;
